import { createContext } from 'react';

export const SupportedDateFormatsContext = createContext([{ dateFnsFormat: 'yyyy-MM-dd' }]);
